import {Alert, Box, Typography, useTheme} from "@mui/material";
import React from "react";

interface Props {
    message?: string;
    link?: React.ReactElement;
}

const ErrorBox = ({ message, link } : Props) => {
    
    const theme = useTheme();
    
    if(!message)
    {
        return <></>;
    }
    
    return <Box display={"flex"} flexDirection={"column"} bgcolor={`${theme.palette.thatsMe.surfacePrimary}3C`}>
        <Alert variant="outlined" severity="error">
            <Typography variant={"body2"} color={theme.palette.thatsMe.textPrimary} display={"inline"}>
                {link ? <>{message}&nbsp;{link}</> : message }
            </Typography>
        </Alert>
    </Box>;
};

export default ErrorBox;